import client from '../httpClient';

const settingGroupStoreGetAreaListApi = (params) => {
  return client.get('/store-groups/settings/areas/', JSON.stringify(params));
};

export default settingGroupStoreGetAreaListApi;
